import { Component, EventEmitter, Input, Output, computed, inject, input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeHtml } from 'node_modules/@angular/platform-browser';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from '../enums';

export type AlertType = typeof ALERT_TYPE[keyof typeof ALERT_TYPE];

@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss'],
    standalone: false
})
export class AlertDialogComponent {
  private activeModal = inject(NgbActiveModal);
  private sanitizer = inject(DomSanitizer);
  protected enums = inject(Enums);

  @Input() message: string;
  processedMessage = computed<SafeHtml>(() => {
    const msg = this.message;
    return this.isHtml(msg) ? this.sanitizer.bypassSecurityTrustHtml(msg) : msg;
  })

  @Input() alertType: AlertType;
  @Output() okClicked = new EventEmitter<void>();

  private isHtml(msg: string) {
    if (!msg) return false;
    const doc = new DOMParser().parseFromString(msg, 'text/html');
    return Array.from(doc.body.childNodes).some(node => node.nodeType === Node.ELEMENT_NODE);
  }

  checkType() {
    switch (this.alertType) {
      case ALERT_TYPE.DANGER:
        return 'danger';
      case ALERT_TYPE.SUCCESS:
        return 'success';
    }
  }

  closeModal() {
    this.okClicked.emit();
    this.activeModal.close();
  }
}
